(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7878],{

/***/ 91882:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/browser-history",
      function () {
        return __webpack_require__(75695);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76039);
/* harmony import */ var src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31909);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50607);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15378);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34745);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74743);
/* harmony import */ var src_components_DateRangeFilter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99442);













const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z;
const AndroidBrowserHistory = (param)=>{
    let {} = param;
    var ref;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const [allData, setAllData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) //所有的数据
    ;
    const [showData, setShowData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) //展示的数据
    ;
    const [showDate, setShowDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) //展示日期
    ;
    const [date, setDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        "All"
    ]) //日期
    ;
    const [from, setFrom] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //开始日期
    ;
    const [to, setTo] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //结束日期
    ;
    const [fromTime, setFromTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //开始日期时间戳
    ;
    const [toTime, setToTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") //结束日期时间戳
    ;
    const rangeDom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [dates, setDates] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { context , data: deviceData , loading: isLoading , loadNext , setDateRange  } = (0,src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_5__/* .useAndroidDevicePagedData */ .v)({
        source: "local",
        category: "CHROME_HISTORY",
        limit: 100
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAllData(deviceData);
    }, [
        deviceData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setShowData([]);
        setShowDate(false);
        setDate([
            "All"
        ]);
        setFrom("");
        setTo("");
        setFromTime("");
        setToTime("");
        setDates([]);
    }, [
        context === null || context === void 0 ? void 0 : context.requestKey
    ]);
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (scroll >= 100) loadNext();
    }, [
        loadNext,
        scroll
    ]);
    //更新 fromTime 和 toTime（同时把区间交给接口筛选）
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (date.length === 1 && date[0] !== "All") {
            const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_6__/* .buildPresetTimeParams */ .z6)(date[0]);
            setFromTime(startTime);
            setToTime(endTime);
            setDateRange({
                startTime,
                endTime
            });
        } else if (date.length === 2) {
            const { startTime: startTime1 , endTime: endTime1  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_6__/* .buildTimeParams */ .W2)(date);
            setFromTime(startTime1);
            setToTime(endTime1);
            setDateRange({
                startTime: startTime1,
                endTime: endTime1
            });
        } else {
            setFromTime("");
            setToTime("");
            setDateRange(null);
        }
    }, [
        date,
        setDateRange
    ]);
    // 日期按钮
    const button = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-[calc(50%-5px)] smj:w-[172px] h-[40px] bg-[#2A99FF] border border-[#E5E7EB] rounded-[8px] flex justify-center items-center cursor-pointer relative px-[10px] Blds:w-auto Blds:min-w-[172px]",
            onClick: (e)=>{
                e.stopPropagation();
                setShowDate((val)=>!val);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    className: "ml-[2px]",
                    src: "/images/record-screen/calendar2.svg",
                    width: 20,
                    height: 20,
                    alt: "calendar"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "text-[14px] leading-[16px] text-white mx-[10px]",
                    children: [
                        date.length === 1 && date[0],
                        date.length === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                date[0],
                                " ~ ",
                                date[1]
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .motion.div */ .E.div, {
                    initial: {
                        rotate: 0
                    },
                    animate: {
                        rotate: showDate ? 180 : 0
                    },
                    transition: {
                        duration: 0.2
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                        src: "/images/record-screen/union.svg",
                        width: 16,
                        height: 16,
                        alt: "drop down"
                    })
                }),
                showDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .motion.div */ .E.div, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    transition: {
                        duration: 0.2
                    },
                    className: "w-full drop-shadow-[0_0_3px_rgba(0,0,0,0.1)] bg-[#FFF] rounded-[6px] flex flex-col text-[14px] text-[#666666] absolute top-[38px] p-[10px] z-30 relative",
                    onClick: (e)=>{
                        e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "border border-[#E5E5E5] rounded-[3px] text-[14px] text-[rgba(0,0,0,0.9)]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px] hover:text-[#2A99FF]",
                                    onClick: ()=>{
                                        setDate([
                                            "All"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("All")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px] hover:text-[#2A99FF]",
                                    onClick: ()=>{
                                        setDate([
                                            "Today"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Today")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px] hover:text-[#2A99FF]",
                                    onClick: ()=>{
                                        setDate([
                                            "Last 7 days"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Last 7 days")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px] hover:text-[#2A99FF]",
                                    onClick: ()=>{
                                        setDate([
                                            "Last 14 days"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Last 14 days")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px] hover:text-[#2A99FF]",
                                    onClick: ()=>{
                                        setDate([
                                            "Last 30 days"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Last 30 days")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px] hover:text-[#2A99FF]",
                                    onClick: ()=>{
                                        const currentDate = new Date();
                                        const xxDaysAgo = currentDate.setDate(currentDate.getDate() - 365);
                                        setDate([
                                            "Last Year"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Last Year")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-[12px] text-[#666666] mt-[10px]",
                                    children: t("From")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "border border-[#E5E5E5] rounded-[3px] h-[24px] w-full text-[10px] text-[rgba(0,0,0,0.9)] px-[16px] flex items-center mb-[5px]",
                                    children: from
                                }),
                                t("To"),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "border border-[#E5E5E5] rounded-[3px] h-[24px] w-full text-[10px] text-[rgba(0,0,0,0.9)] px-[16px] flex items-center",
                                    children: to
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RangePicker, {
                                    className: "absolute w-full h-full top-0 left-0 opacity-0",
                                    ref: rangeDom,
                                    value: dates,
                                    onOpenChange: (open)=>{},
                                    onCalendarChange: (dates, dateStrings, info)=>{
                                        setDates([
                                            ...dates
                                        ]);
                                        setFrom(dateStrings[0]);
                                        setTo(dateStrings[1]);
                                    },
                                    allowClear: false
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat(from && to ? "cursor-pointer" : "opacity-60", " mt-[15px] w-full h-[24px] flex justify-center items-center bg-[#FFCF55] rounded-[20px] text-[14px] text-[#000000]"),
                            onClick: ()=>onApply(),
                            children: t("APPLY")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-[11px] w-full h-[24px] flex justify-center items-center text-[14px] text-[#000000] bg-[#E5E5E5] rounded-[20px] cursor-pointer",
                            onClick: ()=>setShowDate(false),
                            children: t("CANCEL")
                        })
                    ]
                })
            ]
        });
    const onApply = ()=>{
        if (!from || !to) return;
        setDate([
            from,
            to
        ]);
        setShowDate(false);
    };
    //筛选数据
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (fromTime && toTime) {
            const results = allData.filter((item)=>{
                const itemTime = dayjs__WEBPACK_IMPORTED_MODULE_3___default()(item.time).valueOf();
                return fromTime <= itemTime && itemTime <= toTime;
            });
            setShowData(formatDateGroup(results));
        } else {
            setShowData(formatDateGroup(allData));
        }
    }, [
        fromTime,
        toTime,
        allData
    ]);
    // 工具函数：格式化时间
    function formatDateGroup(data) {
        const grouped = {};
        data.forEach((item)=>{
            const dateObj = new Date(item.time);
            const dateStr = dateObj.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });
            const timeStr = dateObj.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });
            if (!grouped[dateStr]) {
                grouped[dateStr] = [];
            }
            grouped[dateStr].push({
                time: timeStr,
                title: item.title,
                url: item.url
            });
        });
        // 转换成数组格式
        const result = Object.entries(grouped).map((param)=>{
            let [date, list] = param;
            return {
                date,
                list
            };
        });
        // const result = Object.entries(grouped).map(([date, list]) => ({
        //   date,
        //   list: [...list].sort((a, b) => {
        //     return dayjs(a.time, 'hh:mm A') - dayjs(b.time, 'hh:mm A') // 每天日期里的数组时间顺序排序
        //   })
        // }))
        // 可选：按日期降序排列
        result.sort((a, b)=>new Date(b.date) - new Date(a.date));
        return result;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Browser History");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full flex smj:flex-col !h-[calc(var(--vh2)*100-215px)] smj:!h-[calc(var(--vh2)*100-92px)] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-[330px] flex-shrink-0 smj:w-full border-[#E7E8EC] smjs:border-r-[1px] smj:border-b-[1px] p-[15px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    className: "h-[40px] w-full text-[14px] placeholder:text-[#818187] text-[#282938] border-[1px] border-[#E3E3E5] rounded-[8px] pl-[44px]",
                                    placeholder: t("Search Browser History")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-0 left-0 flex items-center h-full pl-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: "/images/contacts/search.svg",
                                        className: "w-[20px] h-[20px]",
                                        width: 20,
                                        height: 20,
                                        alt: "Search"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between mt-4 p-3 bg-[#F4F5F7] rounded-[6px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            src: "/images/navigation/chrome.svg",
                                            width: 36,
                                            height: 36,
                                            alt: "chrome"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-[16px] text-[#222222] ml-[7px]",
                                            children: "Chrome"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-[14px] text-[#949494]",
                                    children: (ref = showData[0]) === null || ref === void 0 ? void 0 : ref.date
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-grow relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full p-[10px] flex items-center justify-between border-[#E7E8EC] smjs:border-b-[1px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            src: "/images/navigation/chrome.svg",
                                            width: 36,
                                            height: 36,
                                            alt: "chrome"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-[16px] font-[600] text-black ml-[7px]",
                                            children: "Chrome"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DateRangeFilter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    value: date,
                                    onChange: setDate,
                                    className: "w-[calc(50%-5px)] smj:w-[172px] Blds:w-auto Blds:min-w-[172px]"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: dom,
                            className: "p-[10px] !max-h-[calc(var(--vh2)*100-276px)] smj:!max-h-[calc(var(--vh2)*100-300px)] overflow-y-auto overflow-x-hidden grid gap-4",
                            children: showData.map((item, i)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-white rounded-[10px] [box-shadow:0px_0px_12px_0px_#0000001A] h-fit relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-[50px] flex items-center pl-[14px] smj:pl-[10px] border-[#E7E8EC] border-b-[1px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[16px] text-[#222222]",
                                                children: item.date
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "grid gap-4 py-4 pl-[14px] smj:px-[10px] text-[14px] leading-[22px]",
                                            children: item.list.map((it, i)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "grid grid-cols-[auto_1fr] gap-[28px] smj:gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-[#22222299]",
                                                            children: it.time
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex smj:flex-col overflow-hidden",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "text-[#222222CC]",
                                                                    children: it.title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: it.url,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "text-[#2A99FF] smjs:ml-[28px] line-clamp-1 break-words",
                                                                    children: it.url
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        })
                                    ]
                                }, i);
                            })
                        }),
                        isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                        }) : null,
                        allData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none",
                            children: [
                                t("It appears theres no data to show here yet"),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                t("If data exists it may take up to 1 hour to download and appear"),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                t("We suggest checking back in a little while")
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AndroidBrowserHistory);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1033,8914,3368,1675,5378,607,9368,9774,2888,179], function() { return __webpack_exec__(91882); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);